function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import React, { useEffect, useRef } from 'react';
import { Checkbox, FormControl, FormControlLabel, FormGroup, List, ListItem, Typography } from '@applyboard/ui-components';
import { CheckboxWithChildren } from "./CheckboxWithChildren";
import ErrorMessage from "../CEF/Common/ErrorMessage";
function areParentOptions(options) {
  return options.some(function (option) {
    return 'children' in option;
  });
}
export var CheckboxListField = function CheckboxListField(_ref) {
  var label = _ref.label,
    value = _ref.value,
    onChange = _ref.onChange,
    options = _ref.options,
    selectedTags = _ref.selectedTags,
    setSelectedTags = _ref.setSelectedTags,
    popularIntakes = _ref.popularIntakes,
    helperText = _ref.helperText;
  var withNestedLists = areParentOptions(options);
  return /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    component: "legend",
    style: {
      paddingBottom: '8px'
    }
  }, label), /*#__PURE__*/React.createElement(FormGroup, null, withNestedLists ? /*#__PURE__*/React.createElement(CheckboxWithChildren, {
    options: options,
    value: value,
    onChange: onChange,
    selectedTags: selectedTags,
    setSelectedTags: setSelectedTags,
    popularIntakes: popularIntakes
  }) : /*#__PURE__*/React.createElement(SimpleCheckboxList, {
    options: options,
    value: value,
    onChange: onChange
  })), helperText && /*#__PURE__*/React.createElement(ErrorMessage, {
    message: helperText
  }));
};
var SimpleCheckboxList = function SimpleCheckboxList(_ref2) {
  var value = _ref2.value,
    onChange = _ref2.onChange,
    options = _ref2.options;
  return /*#__PURE__*/React.createElement(List, {
    style: {
      padding: '16px 0 0'
    }
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement(CheckboxListItem, {
      key: option.name,
      option: option,
      onChange: onChange,
      value: value
    });
  }));
};
export var CheckboxListItem = function CheckboxListItem(_ref3) {
  var option = _ref3.option,
    _onChange = _ref3.onChange,
    value = _ref3.value,
    selectedTags = _ref3.selectedTags,
    setSelectedTags = _ref3.setSelectedTags,
    popularIntakes = _ref3.popularIntakes;
  var ListItemStyle = {
    padding: '0 0 0 8px'
  };
  var previousSelectedTagsRef = useRef(selectedTags);
  var setValueWithTags = function setValueWithTags() {
    var previousSelectedTags = new Set(previousSelectedTagsRef.current);
    var currentSelectedTags = new Set(selectedTags);
    var addedTags = Array.from(currentSelectedTags).filter(function (tag) {
      return !previousSelectedTags.has(tag);
    });
    var removedTags = Array.from(previousSelectedTags).filter(function (tag) {
      return !currentSelectedTags.has(tag);
    });
    previousSelectedTagsRef.current = selectedTags;
    var toRemove = new Set(removedTags);
    var uniqueItems = new Set([].concat(_toConsumableArray(value), _toConsumableArray(addedTags)));
    var newValue = Array.from(uniqueItems).filter(function (item) {
      return !toRemove.has(item);
    });
    _onChange(newValue);
  };
  useEffect(function () {
    if (selectedTags && popularIntakes) {
      setValueWithTags();
    }
  }, [selectedTags]);
  return /*#__PURE__*/React.createElement(ListItem, {
    key: option.name,
    style: ListItemStyle
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    key: option.name,
    control: /*#__PURE__*/React.createElement(Checkbox, {
      name: option.name,
      checked: value.includes(option.name),
      onChange: function onChange(event) {
        if (selectedTags && popularIntakes) {
          var intakeIsPopular = popularIntakes.find(function (intake) {
            return intake.name === option.name;
          });
          if (intakeIsPopular) {
            if (event.target.checked) {
              setSelectedTags([].concat(_toConsumableArray(selectedTags), [option.name]));
            } else {
              setSelectedTags(selectedTags.filter(function (tag) {
                return tag !== option.name;
              }));
            }
          }
        }
        var obj = event.target.checked ? [].concat(_toConsumableArray(value), [option.name]) : value.filter(function (v) {
          return v !== option.name;
        });
        _onChange(obj);
      }
    }),
    label: /*#__PURE__*/React.createElement(Typography, {
      variant: "paragraph"
    }, option.label)
  }));
};